/* WithIt Corp — theme scripts (vanilla JS replacement for React / framer-motion / GSAP) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  if (designMode) document.documentElement.classList.add('shopify-design-mode');

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ------------------------------------------------------------------
     Header offset (sticky header height) for anchor scrolling
     ------------------------------------------------------------------ */
  function headerHeight() {
    var h = $('[data-site-header]');
    return h ? h.getBoundingClientRect().height : 0;
  }
  function updateHeaderOffset() {
    document.documentElement.style.setProperty('--header-offset', Math.round(headerHeight()) + 'px');
  }

  function scrollToId(id, smooth) {
    if (!id || id === 'home') {
      window.scrollTo({ top: 0, behavior: smooth ? 'smooth' : 'auto' });
      return true;
    }
    var el = document.getElementById(id);
    if (!el) return false;
    // Ignore any in-progress reveal transform so we land on the element's final position
    var ty = 0, tf = getComputedStyle(el).transform;
    if (tf && tf !== 'none') { var m = tf.match(/matrix\(([^)]+)\)/); if (m) ty = parseFloat(m[1].split(',')[5]) || 0; }
    var extra = id.indexOf('product-') === 0 ? 24 : 0; // breathing room above product cards (as original)
    var y = el.getBoundingClientRect().top - ty + window.pageYOffset - headerHeight() - extra;
    window.scrollTo({ top: Math.max(0, y), behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
    return true;
  }

  /* Same-page hash links → smooth scroll with header compensation */
  function initAnchorLinks() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="#"]');
      if (!a || a.hasAttribute('data-no-link')) return;
      var url;
      try { url = new URL(a.getAttribute('href'), window.location.href); } catch (err) { return; }
      if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
      var id = decodeURIComponent(url.hash.slice(1));
      if (!id) return;
      if (id === 'home' || document.getElementById(id)) {
        e.preventDefault();
        closeMobileMenu();
        closeDropdowns();
        scrollToId(id, true);
        if (history.replaceState) history.replaceState(null, '', id === 'home' ? url.pathname : '#' + id);
      }
    });

    /* Arriving from another page with a hash (e.g. /#bulk-buying) */
    if (window.location.hash && window.location.hash.length > 1) {
      var id = decodeURIComponent(window.location.hash.slice(1));
      if (id === 'contact_form') return; // Shopify form redirect anchor
      window.addEventListener('load', function () {
        setTimeout(function () { scrollToId(id, false); }, 60);
      });
    }
  }

  /* ------------------------------------------------------------------
     Scroll spy for the main nav (home page only)
     ------------------------------------------------------------------ */
  function initScrollSpy() {
    var links = $$('.main-nav__link').filter(function (a) {
      var href = a.getAttribute('href') || '';
      return href.indexOf('#') !== -1;
    });
    if (!links.length) return;
    var map = links.map(function (a) {
      var url;
      try { url = new URL(a.getAttribute('href'), window.location.href); } catch (e) { return null; }
      if (url.pathname !== window.location.pathname) return null;
      return { link: a, id: decodeURIComponent(url.hash.slice(1)) };
    }).filter(Boolean);
    if (!map.length) return;

    function onScroll() {
      var offset = headerHeight() + 10;
      var current = '';
      map.forEach(function (m) {
        var el = document.getElementById(m.id);
        if (!el) return;
        var r = el.getBoundingClientRect();
        if (r.top <= offset && r.bottom > offset) current = m.id;
      });
      if (window.innerHeight + Math.round(window.scrollY) >= document.documentElement.scrollHeight - 10) {
        var last = map[map.length - 1];
        if (document.getElementById(last.id)) current = last.id;
      }
      if (!current && window.scrollY < 50) current = 'home';
      map.forEach(function (m) { m.link.classList.toggle('is-active', m.id === current); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ------------------------------------------------------------------
     Announcement bar rotation
     ------------------------------------------------------------------ */
  function initAnnouncement(ctx) {
    $$('[data-announcement]', ctx).forEach(function (bar) {
      var items = $$('[data-announcement-item]', bar);
      if (items.length < 2) return;
      var i = 0;
      var interval = parseInt(bar.getAttribute('data-interval'), 10) || 3000;
      setInterval(function () {
        var prev = items[i];
        prev.classList.remove('is-active');
        prev.classList.add('is-leaving');
        setTimeout(function () { prev.classList.remove('is-leaving'); }, 520);
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, interval);
    });
  }

  /* ------------------------------------------------------------------
     Desktop products dropdown
     ------------------------------------------------------------------ */
  function closeDropdowns(except) {
    $$('[data-dropdown].is-open').forEach(function (d) {
      if (d === except) return;
      d.classList.remove('is-open');
      var t = $('[data-dropdown-trigger]', d);
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }
  function initDropdowns() {
    var canHover = window.matchMedia('(hover: hover)').matches;
    $$('[data-dropdown]').forEach(function (dd) {
      var trigger = $('[data-dropdown-trigger]', dd);
      function open() { closeDropdowns(dd); dd.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); }
      function close() { dd.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); }
      if (canHover) {
        dd.addEventListener('mouseenter', open);
        dd.addEventListener('mouseleave', close);
      }
      trigger.addEventListener('click', function (e) {
        if (!canHover) {
          // Touch: first tap opens, second tap follows the link
          if (!dd.classList.contains('is-open')) { e.preventDefault(); open(); return; }
        }
        close();
      });
      dd.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); trigger.focus(); } });
      dd.addEventListener('focusout', function (e) { if (!dd.contains(e.relatedTarget)) close(); });
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); open(); var first = $('.dropdown__item', dd); if (first) first.focus(); }
      });
    });
    document.addEventListener('mousedown', function (e) {
      if (!e.target.closest('[data-dropdown]')) closeDropdowns();
    });
  }

  /* ------------------------------------------------------------------
     Mobile menu
     ------------------------------------------------------------------ */
  function closeMobileMenu() {
    var m = $('[data-mobile-menu]');
    if (!m || !m.classList.contains('is-open')) return;
    m.classList.remove('is-open');
    $('[data-mobile-panel]', m).hidden = true;
    var t = $('[data-mobile-toggle]', m);
    t.setAttribute('aria-expanded', 'false');
    t.setAttribute('aria-label', 'Open navigation');
  }
  function initMobileMenu() {
    var m = $('[data-mobile-menu]');
    if (!m) return;
    var toggle = $('[data-mobile-toggle]', m);
    var panel = $('[data-mobile-panel]', m);
    toggle.addEventListener('click', function () {
      var open = !m.classList.contains('is-open');
      m.classList.toggle('is-open', open);
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
    });
    panel.addEventListener('click', function (e) { if (e.target.closest('a')) setTimeout(closeMobileMenu, 0); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMobileMenu(); });
  }

  /* ------------------------------------------------------------------
     Reveal on scroll (framer-motion whileInView replacement)
     ------------------------------------------------------------------ */
  function initReveal(ctx) {
    // Immediate (on-load) reveals
    requestAnimationFrame(function () {
      $$('.reveal--now', ctx).forEach(function (el) { el.classList.add('is-visible'); });
    });

    var targets = $$('[data-reveal]', ctx);
    var staggers = $$('[data-stagger]', ctx);
    var inviews = $$('[data-inview]', ctx);

    if (!('IntersectionObserver' in window) || designMode) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      staggers.forEach(function (g) { $$('.reveal', g).forEach(function (el) { el.classList.add('is-visible'); }); });
      inviews.forEach(function (el) { el.classList.add('is-inview'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        if (el.hasAttribute('data-stagger')) {
          $$('.reveal', el).forEach(function (c) { c.classList.add('is-visible'); });
        } else if (el.hasAttribute('data-inview')) {
          el.classList.add('is-inview');
        } else {
          el.classList.add('is-visible');
        }
        io.unobserve(el);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

    targets.concat(staggers).concat(inviews).forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------------
     Hero rotating apparel showcase
     ------------------------------------------------------------------ */
  function initShowcase(ctx) {
    $$('[data-showcase]', ctx).forEach(function (sc) {
      var items = $$('[data-showcase-item]', sc);
      if (items.length !== 3 || reduceMotion) return;
      var current = 0;
      var interval = parseInt(sc.getAttribute('data-interval'), 10) || 3800;
      function layout() {
        items.forEach(function (item, i) {
          var pos = i === current ? 'front' : (i === (current + 1) % 3 ? 'back-left' : 'back-right');
          item.setAttribute('data-pos', pos);
        });
      }
      layout();
      setInterval(function () { current = (current + 1) % 3; layout(); }, interval);
    });
  }

  /* ------------------------------------------------------------------
     Customer showcase: horizontal scroller with prev/next + drag
     ------------------------------------------------------------------ */
  function initCustomerScroller(ctx) {
    $$('[data-cust-scroller]', ctx).forEach(function (root) {
      if (root.__ready) return; root.__ready = true;
      var track = $('[data-cust-track]', root);
      var prev = $('[data-cust-prev]', root);
      var next = $('[data-cust-next]', root);
      if (!track) return;

      function bounds() {
        if (!prev || !next) return;
        prev.disabled = track.scrollLeft <= 6;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 6;
      }
      function stepBy(dir) {
        var card = $('[data-cust-card]', track);
        var w = card ? card.getBoundingClientRect().width : 300;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 24;
        track.scrollBy({ left: (w + gap) * dir, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { stepBy(-1); });
      if (next) next.addEventListener('click', function () { stepBy(1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); stepBy(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); stepBy(-1); }
      });
      track.addEventListener('scroll', bounds, { passive: true });
      window.addEventListener('resize', bounds);

      // Mouse drag-to-scroll
      var drag = false, startX = 0, startLeft = 0, moved = false;
      track.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        drag = true; moved = false; startX = e.pageX; startLeft = track.scrollLeft;
        track.classList.add('is-dragging');
      });
      window.addEventListener('mousemove', function (e) {
        if (!drag) return;
        e.preventDefault();
        var walk = (e.pageX - startX) * 1.3;
        if (Math.abs(walk) > 4) moved = true;
        track.scrollLeft = startLeft - walk;
      });
      window.addEventListener('mouseup', function () {
        if (!drag) return;
        drag = false; track.classList.remove('is-dragging'); bounds();
      });
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });

      // Theme editor: selecting a customer block scrolls it into view
      document.addEventListener('shopify:block:select', function (e) {
        if (!track.contains(e.target)) return;
        track.scrollTo({ left: e.target.offsetLeft - track.firstElementChild.offsetLeft, behavior: 'smooth' });
      });

      bounds();
      window.addEventListener('load', bounds);
    });
  }

  /* ------------------------------------------------------------------
     Testimonials infinite marquee with centre highlight
     ------------------------------------------------------------------ */
  function initMarquee(ctx) {
    $$('[data-marquee]', ctx).forEach(function (container) {
      var track = $('[data-marquee-track]', container);
      if (!track) return;
      var speed = parseFloat(container.getAttribute('data-speed')) || 0.65;
      var pos = 0, paused = false, resumeTimer = null, visible = true;
      var cards = $$('[data-card-id]', track);
      var lastId = null;

      function highlight() {
        var cr = container.getBoundingClientRect();
        var center = cr.left + cr.width / 2;
        var best = null, min = Infinity;
        cards.forEach(function (c) {
          var r = c.getBoundingClientRect();
          var d = Math.abs(center - (r.left + r.width / 2));
          if (d < min) { min = d; best = c; }
        });
        if (!best) return;
        var id = best.getAttribute('data-card-id');
        if (id === lastId) return;
        lastId = id;
        cards.forEach(function (c) { c.classList.toggle('is-highlighted', c.getAttribute('data-card-id') === id); });
      }

      function frame() {
        if (!paused && visible && !reduceMotion) {
          pos += speed;
          var single = track.scrollWidth / 3;
          if (pos >= single) pos -= single;
          track.style.transform = 'translate3d(-' + pos + 'px,0,0)';
          highlight();
        }
        requestAnimationFrame(frame);
      }

      container.addEventListener('mouseenter', function () { paused = true; });
      container.addEventListener('mouseleave', function () { paused = false; });
      container.addEventListener('touchstart', function () { paused = true; clearTimeout(resumeTimer); }, { passive: true });
      container.addEventListener('touchend', function () { resumeTimer = setTimeout(function () { paused = false; }, 1200); });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(container);
      }
      highlight();
      requestAnimationFrame(frame);
    });
  }

  /* ------------------------------------------------------------------
     Request-a-Quote bubbles (replay every 9 s like the original)
     ------------------------------------------------------------------ */
  function initBubbles(ctx) {
    $$('[data-bubbles]', ctx).forEach(function (wrap) {
      if (reduceMotion || designMode) { wrap.classList.add('is-playing'); return; }
      function play() {
        wrap.classList.remove('is-playing');
        void wrap.offsetWidth; // restart CSS animations
        wrap.classList.add('is-playing');
      }
      var started = false;
      function start() { if (started) return; started = true; play(); setInterval(play, 9000); }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { start(); io.disconnect(); } });
        io.observe(wrap);
      } else start();
    });
  }

  /* ------------------------------------------------------------------
     Lead forms: validation + optional Formspree AJAX submit
     ------------------------------------------------------------------ */
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function validateField(input) {
    var rules = (input.getAttribute('data-validate') || '').split(/\s+/).filter(Boolean);
    var v = (input.value || '').trim();
    var msg = '';
    if (rules.indexOf('required') > -1 && !v) msg = input.getAttribute('data-msg-required') || 'This field is required.';
    else if (v && rules.indexOf('email') > -1 && !EMAIL_RE.test(v)) msg = input.getAttribute('data-msg-email') || 'Please enter a valid email address.';
    else if (v && rules.indexOf('phone') > -1 && v.replace(/\D/g, '').length < 10) msg = input.getAttribute('data-msg-phone') || 'Please enter a valid phone number.';
    var err = input.form.querySelector('[data-error-for="' + input.id + '"]');
    if (err) err.textContent = msg;
    input.classList.toggle('has-error', !!msg);
    input.setAttribute('aria-invalid', msg ? 'true' : 'false');
    return !msg;
  }

  function initLeadForms(ctx) {
    // Pre-select product from ?product=Name (used by product page "Request a quote" buttons)
    var params = new URLSearchParams(window.location.search);
    var wanted = params.get('product');
    if (wanted) {
      $$('[data-product-select]', ctx).forEach(function (sel) {
        var found = false;
        $$('option', sel).forEach(function (o) { if (o.value.toLowerCase() === wanted.toLowerCase()) { sel.value = o.value; found = true; } });
        if (!found) { var o = document.createElement('option'); o.value = wanted; o.textContent = wanted; sel.appendChild(o); sel.value = wanted; }
      });
    }

    $$('[data-lead-form]', ctx).forEach(function (form) {
      var fields = $$('[data-validate]', form);
      fields.forEach(function (f) {
        f.addEventListener('input', function () {
          if (f.classList.contains('has-error')) validateField(f);
        });
      });

      form.addEventListener('submit', function (e) {
        var ok = true, firstBad = null;
        fields.forEach(function (f) { if (!validateField(f)) { ok = false; if (!firstBad) firstBad = f; } });
        if (!ok) { e.preventDefault(); firstBad.focus(); return; }

        var btn = $('[data-submit]', form);
        var label = btn ? btn.querySelector('[data-submit-text]') || btn : null;
        if (btn) { btn.disabled = true; if (label) label.textContent = btn.getAttribute('data-busy-label'); }

        if (!form.hasAttribute('data-formspree')) return; // native Shopify POST

        e.preventDefault();
        var success = $('[data-form-success]', form);
        var error = $('[data-form-error]', form);
        if (success) success.hidden = true;
        if (error) error.hidden = true;

        var body = {};
        new FormData(form).forEach(function (v, k) { body[k] = v; });
        body._subject = form.getAttribute('data-subject') || 'Website Submission';
        if (body.email) body._replyto = body.email; else delete body.email;

        fetch(form.action, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        }).then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (data) {
            if (!res.ok) {
              var m = 'Failed to submit form. Please try again.';
              if (data && data.errors && data.errors.length) m = data.errors.map(function (x) { return x.message; }).join(', ');
              else if (data && data.error) m = data.error;
              throw new Error(m);
            }
          });
        }).then(function () {
          form.reset();
          if (success) { success.hidden = false; success.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        }).catch(function (err) {
          if (error) {
            var t = $('[data-form-error-text]', error);
            if (t) t.textContent = err.message || 'There was an issue sending your request. Please try again.';
            error.hidden = false;
          }
        }).then(function () {
          if (btn) { btn.disabled = false; if (label) label.textContent = btn.getAttribute('data-label'); }
        });
      });
    });

    // After a native Shopify submit the page reloads at #contact_form; bring the alert into view
    if (window.location.hash === '#contact_form') {
      var alert = $('.form-alert--success:not([hidden]), .form-alert--error:not([hidden])');
      if (alert) setTimeout(function () { scrollToElement(alert); }, 100);
    }
  }

  function scrollToElement(el) {
    var y = el.getBoundingClientRect().top + window.pageYOffset - headerHeight() - 24;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }

  /* ------------------------------------------------------------------
     Product page: variant picker, gallery, quantity
     ------------------------------------------------------------------ */
  function formatMoney(cents, format) {
    format = format || '₹{{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = withCommas + '.' + parts[1];
    var noDecimals = withCommas;
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_no_decimals') return noDecimals;
      if (key === 'amount_with_comma_separator') return amount.replace('.', ',');
      return amount;
    });
  }

  function initProduct() {
    $$('[data-product]').forEach(function (root) {
      var jsonEl = $('[data-product-json]', root);
      if (!jsonEl) return;
      var product = JSON.parse(jsonEl.textContent);
      var moneyFormat = root.getAttribute('data-money-format');
      var idInput = $('[name="id"]', root);
      var priceEl = $('[data-price]', root);
      var compareEl = $('[data-compare]', root);
      var addBtn = $('[data-add-to-cart]', root);
      var mainImg = $('[data-main-image]', root);

      function selectedOptions() {
        return $$('[data-option-index]', root).map(function (fs) {
          var c = $('input:checked', fs);
          return c ? c.value : null;
        });
      }
      function update() {
        var opts = selectedOptions();
        var v = product.variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
        if (!v) { if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; } return; }
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = formatMoney(v.price, moneyFormat);
        if (compareEl) { compareEl.textContent = v.compare_at_price > v.price ? formatMoney(v.compare_at_price, moneyFormat) : ''; }
        if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? addBtn.getAttribute('data-label') : 'Sold out'; }
        if (v.featured_image && mainImg) { mainImg.src = v.featured_image.src; mainImg.removeAttribute('srcset'); }
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        history.replaceState(null, '', url.toString());
      }
      $$('[data-option-index] input', root).forEach(function (i) { i.addEventListener('change', update); });

      $$('[data-thumb]', root).forEach(function (t) {
        t.addEventListener('click', function () {
          $$('[data-thumb]', root).forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
          if (mainImg) { mainImg.src = t.getAttribute('data-src'); mainImg.removeAttribute('srcset'); }
        });
      });
    });

    $$('[data-qty]').forEach(function (q) {
      var input = $('input', q);
      $$('button', q).forEach(function (b) {
        b.addEventListener('click', function () {
          var step = b.getAttribute('data-step') === '-1' ? -1 : 1;
          var min = parseInt(input.min, 10) || 1;
          input.value = Math.max(min, (parseInt(input.value, 10) || min) + step);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ------------------------------------------------------------------ */
  function init() {
    updateHeaderOffset();
    window.addEventListener('resize', updateHeaderOffset);
    initAnchorLinks();
    initScrollSpy();
    initAnnouncement();
    initDropdowns();
    initMobileMenu();
    initReveal();
    initShowcase();
    initCustomerScroller();
    initMarquee();
    initBubbles();
    initLeadForms();
    initProduct();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor: re-run initialisers when a section is re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    var ctx = e.target;
    initReveal(ctx); initShowcase(ctx); initCustomerScroller(ctx);
    initMarquee(ctx); initBubbles(ctx); initLeadForms(ctx); initAnnouncement(ctx);
    updateHeaderOffset();
  });
})();
